import React, { useEffect } from 'react';
import * as jnb from 'react-bootstrap';
import * as Yup from "yup";
import { ErrorMessage, Field, FormikProvider, useFormik } from 'formik';
import { useState } from 'react';
import Swal from 'sweetalert2';
import { AADHAR_VALIDATION, ALPHABETS_ONLY, ALPHABETS_ONLY_Msg, ERROR_MSG, handleInputToUppercase, handleKeyPressAlphabets, handleKeyPressNumeric, MOBILE_VALIDATION, public_url } from '../CommonUtils/Validations/RegularExpAndVar';
import PublicHeader from '../Header/PublicHeader';
import allowNumbersOnly from '../CommonUtils/Validations/CommonValidations';
import { CommomLoginAunthenticatePost } from '../CommonUtils/CommonAxios/CommonAxios';
import { config } from '../CommonUtils/CommonUrl/CommonUrls';
import Sweetalert from '../CommonUtils/CommonPopupAndAlerts/SweetAlerts';
import { useNavigate } from 'react-router-dom';
import { FaEye, FaEyeSlash } from 'react-icons/fa';

export default function RegistrationForm() {
    const [showData, setData] = useState(false);
    const [minutes, setMinutes] = useState(1);
    const [seconds, setSeconds] = useState(30);
      const [showSendOTP, setShowSendOTP] = useState(true);
     const [timerActive, setTimerActive] = useState(false);
    const aadhaarRegex = /^[2-9][0-9]{11}$/;
    const phoneRegex = /^[6-9]{1}[0-9]{9}$/;

    const userValidations = Yup.object().shape({
        aadhaar: Yup.string().required(ERROR_MSG).matches(AADHAR_VALIDATION, "Invalid aadhar Number"),
        applicantName: Yup.string().required(ERROR_MSG).matches(ALPHABETS_ONLY, ALPHABETS_ONLY_Msg),
        citizen: Yup.string().required(ERROR_MSG),
        fatherName: Yup.string().required(ERROR_MSG).matches(ALPHABETS_ONLY, ALPHABETS_ONLY_Msg),
        phoneno: Yup.string().required(ERROR_MSG).matches(MOBILE_VALIDATION, "Invalid Phone Number"),
        otp: Yup.string().required(ERROR_MSG),
        pwd: Yup.string().required("Please enter your password").matches(
            /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{8,})/,
            "Must Contain 8 Characters, One Uppercase, One Lowercase, One Number and One Special Case Character"
        ),
        repwd: Yup.string().oneOf([Yup.ref("pwd"), null], "Passwords must match").required("Confirm password is required"),
        dob: Yup.string().required(ERROR_MSG).nullable(),
    })

    const formIk = useFormik({
        initialValues: {
            aadhaar: '',
            applicantName: '',
            fatherName: '',
            phoneno: '',
            otp: '',
            pwd: '',
            repwd: "",
            citizen: '',
            dob: ""
        },
        validationSchema: userValidations,

        onSubmit: (values) => {
            //alert(JSON.stringify(values));
            console.log(values)
            submitDetailsone(values);

            // onSubmit: (values, {resetForm}) => {
            //     alert(JSON.stringify(values));
            //     submitDetailsone(values, resetForm);

            // console.log("values>>>>>", values);
        }
    })

    const today = new Date();
    // 20 years ago = maximum date allowed
    const twentyYearsAgo = new Date(today.getFullYear() - 20, today.getMonth(), today.getDate());
    const maxDate = twentyYearsAgo.toISOString().split('T')[0];
    // 60 years ago = minimum date allowed
    const sixtyYearsAgo = new Date(today.getFullYear() - 60, today.getMonth(), today.getDate());
    const minDate = sixtyYearsAgo.toISOString().split('T')[0];

    const maxxDate = new Date();
    maxxDate.setFullYear(maxxDate.getFullYear() - 80);

    // Format the date in yyyy-mm-dd format (HTML input expects this format)
    // const formattedMaxDate = maxxDate.toISOString().split('T')[0];


    useEffect(() => {
        // console.log("gdfg")
        const interval = setInterval(() => {
            if (seconds > 0) {
                setSeconds(seconds - 1);
            }

            if (seconds === 0) {
                if (minutes === 0) {
                    clearInterval(interval);
                      setTimerActive(false);
                } else {
                    setSeconds(59);
                    setMinutes(minutes - 1);
                }
            }
        }, 1000);

        return () => {
            clearInterval(interval);
        };
    }, [timerActive, minutes,seconds]);

    // const resendOTP = () => {
    //     setMinutes(3);
    //     setSeconds(0);
    // };
    const resendOTP = async () => {
    try {
        let url = config.url.BOC_URL + public_url + "getotp/" + formIk.values.phoneno;
        const res = await CommomLoginAunthenticatePost(url);

        if (res?.data?.scode === "01") {
            Sweetalert("OTP Resent", "success");
            setMinutes(3);
                setSeconds(0);
                 setTimerActive(true);
        } else {
            Sweetalert(res?.data?.sdesc, "error");
            formIk.setFieldValue("otp","")
        }
    } catch (e) {
        console.log("exception at catch block ===>", e);
    }
};

    function Otp() {
        if (formIk.values.aadhaar !== "" && formIk.values.applicantName !== "" && formIk.values.fatherName !== "" && formIk.values.phoneno !== "" && formIk.values.citizen !== "" && formIk.values.dob !== "") {

            if (!aadhaarRegex.test(formIk.values.aadhaar)) {
                Sweetalert('Please enter a valid 12-digit Aadhaar number (starting with 2–9)', 'warning');
                return false;
            }
            if (!phoneRegex.test(formIk.values.phoneno)) {
                Sweetalert('Please enter a valid 10-digit Mobile number (starting with 6-9)', 'warning');
                return false;

            }
            //  setData(true)
            setMinutes(3);
            setSeconds(0);
            return true;
        }
        else { Sweetalert('Please Check Whether you have entered All Fields or not', 'warning') }
        return false;
    }

const [isFormDisabled, setIsFormDisabled] = useState(false);

  
    const submitDetails = async () => {

        try {
            let url = config.url.BOC_URL + public_url + "getotp/" + formIk.values.phoneno;
            const res = await CommomLoginAunthenticatePost(url);
            if (res?.data?.scode === "01") {
                Sweetalert("OTP Sent", "success")
                setData(true)
                 setShowSendOTP(false);
                  setMinutes(3);
            setSeconds(0);
            setTimerActive(true);
              setIsFormDisabled(true);
            }
            else {
                Sweetalert(res?.data?.sdesc , "error").then(() => {
                    setData(false);
                    formIk.setFieldValue("dob", "")
                    formIk.setFieldValue("citizen", "")
                    formIk.setFieldValue("phoneno", "")
                    formIk.setFieldValue("fatherName", "")
                    formIk.setFieldValue("applicantName", "")
                    formIk.setFieldValue("aadhaar", "")
                    setShowSendOTP(true);
                      setIsFormDisabled(false);
                })

            }

        } catch (e) {
            console.log("exception at catch block ===>" + e);
        }
    };

    let navigate = useNavigate()
    const submitDetailsone = async (values) => {
        // const submitDetailsone = async (values, resetForm) => {
        try {
            let url = config.url.BOC_URL + public_url + "usrdtls";
            const res = await CommomLoginAunthenticatePost(url, values);
            //const res = await CommomLoginAunthenticatePost("usrdtls", values);
            //console.log("fffdf", res);

            if (res?.data?.scode === "01") {
                Sweetalert("Registered Successfully", "success").then(() => {
                    navigate("/login");
                })

            }
            else if (res?.data?.scode === "02") {
                Sweetalert(res?.data?.sdesc, "warning").then(()=>{
                    formIk.setFieldValue("otp","")
                })
            }
            else if (res?.data?.scode === "03") {
                Sweetalert(res?.data?.sdesc, "warning")
                formIk.setFieldValue("otp","")
            }

            else {
                Sweetalert(res?.data?.sdesc, "warning")
                formIk.setFieldValue("otp","")
            }

        } catch (e) {
            console.log("exception at catch block ===>" + e);
        }
    };
    const [showPassword, setShowPassword] = useState(false);
    return (
        <>
            <PublicHeader />
            <div className="main_section">  </div>
            <FormikProvider value={formIk}>
                <jnb.Form onSubmit={formIk.handleSubmit} onChange={formIk.handleChange}>
                    <jnb.Container>

                        <div className='text-center mx-5'>
                            <jnb.Row className="px-3 pb-3 ">
                                <jnb.Col xs={12} sm={12} md={12} lg={2} xl={2} xxl={2}></jnb.Col>
                                <jnb.Col xs={12} sm={12} md={12} lg={8} xl={8} xxl={8} >
                                    <div className="inner-herbpage-service-title-sub">
                                        <h1 style={{ fontSize: '30px' }}> Registration Form</h1>
                                    </div>
                                </jnb.Col>
                                <jnb.Col xs={12} sm={12} md={12} lg={2} xl={2} xxl={2}></jnb.Col>
                                <jnb.Col xs={12} sm={12} md={12} lg={2} xl={2} xxl={2}></jnb.Col>

                                <jnb.Col xs={12} sm={12} md={12} lg={8} xl={8} xxl={8} className="jumbotron mt20 form-card-jnb pb-2 bg-white" style={{ marginTop: "5px" }}>
                                    <jnb.Row className="px-2 pt-3">
                                        <jnb.Col xs={12} sm={12} md={12} lg={1} xl={1} xxl={1}></jnb.Col>
                                        <jnb.Col xs={12} sm={12} md={12} lg={5} xl={5} xxl={5}>
                                            <jnb.InputGroup>
                                                {/* className="mb-4p5" */}
                                                <span className="mb-5 mb-md-2 field-mandatory"><b >Name Of The Applicant</b></span>
                                                <Field type="text" name="applicantName" className="form-control w-100 nb-1" maxLength="50" autoComplete="off"
                                                    onKeyPress={(e) => handleKeyPressAlphabets(e)} onInput={(e) => handleInputToUppercase(e)} disabled={isFormDisabled} />
                                                <ErrorMessage name="applicantName" component="div" className="text-error" />
                                            </jnb.InputGroup>
                                        </jnb.Col>
                                        <jnb.Col xs={12} sm={12} md={12} lg={5} xl={5} xxl={5}>
                                            <jnb.InputGroup>
                                                <span className="mb-5 mb-md-2 field-mandatory"><b>Father Name </b></span>
                                                <Field type="text" name="fatherName" className="form-control w-100 nb-1" maxLength="50" autoComplete="off"
                                                    onKeyPress={(e) => handleKeyPressAlphabets(e)} onInput={(e) => handleInputToUppercase(e)}  disabled={isFormDisabled}/>
                                                <ErrorMessage name="fatherName" component="div" className="text-error" />
                                            </jnb.InputGroup>
                                        </jnb.Col>

                                    </jnb.Row>

                                    <jnb.Row className="px-2 pt-3">
                                        <jnb.Col xs={12} sm={12} md={12} lg={1} xl={1} xxl={1}></jnb.Col>
                                        <jnb.Col xs={12} sm={12} md={12} lg={5} xl={5} xxl={5}>
                                            <jnb.InputGroup>
                                                {/* className="mb-5p5" */}
                                                <span className="mb-5 mb-md-2 field-mandatory"><b>Aadhaar No</b></span>
                                                <Field type="text" name="aadhaar" className="form-control w-100 nb-1" maxLength="12" autoComplete="off"
                                                    onKeyPress={(e) => handleKeyPressNumeric(e)} disabled={isFormDisabled} />
                                                <ErrorMessage name="aadhaar" component="div" className="text-error" />
                                            </jnb.InputGroup>
                                        </jnb.Col>

                                        <jnb.Col xs={12} sm={12} md={12} lg={5} xl={5} xxl={5}>
                                            <jnb.InputGroup>
                                                {/* className="mb-4p5" */}
                                                <span className="mb-5 mb-md-2 field-mandatory"><b>Mobile No</b></span>
                                                <Field type="text" name="phoneno" className="form-control w-100 nb-1" maxLength="10" autoComplete="off"
                                                    onKeyPress={(e) => handleKeyPressNumeric(e)} disabled={isFormDisabled} />
                                                <ErrorMessage name="phoneno" component="div" className="text-error" />
                                            </jnb.InputGroup>
                                        </jnb.Col>
                                    </jnb.Row>
                                    <jnb.Row className="px-2 pt-3">
                                        <jnb.Col xs={12} sm={12} md={12} lg={1} xl={1} xxl={1}></jnb.Col>
                                        <jnb.Col xs={12} sm={12} md={12} lg={12} xl={5} xxl={5} >
                                            <jnb.InputGroup className="">
                                                <label>DOB</label>
                                                <Field
                                                    type="date"
                                                    className="form-control w-100 mt-1"
                                                    name="dob"
                                                    value={formIk.values.dob}
                                                    min={minDate}
                                                    max={maxDate}
                                                    autoComplete="off"
                                                    onKeyDown={(e) => e.preventDefault()}
                                                    disabled={isFormDisabled}
                                                />
                                                {/* {ageText && <div className="mt-2 text-danger">Age: {ageText}</div>} */}

                                                <ErrorMessage name="dob" component="div" className="text-error" />
                                            </jnb.InputGroup>
                                        </jnb.Col>
                                        <jnb.Col xs={12} sm={12} md={12} lg={5} xl={5} xxl={5}>
                                            <jnb.InputGroup>
                                                {/* className="mb-5p5" */}
                                                <span className="mb-5 mb-md-2 field-mandatory"><b>Are You a?</b></span>
                                                <Field as="select" name="citizen" className="form-control w-100 nb-1" maxLength="12" autoComplete="off" disabled={isFormDisabled}>
                                                    <option value='0'>----Select----</option>
                                                    <option value='citizen-7'>Worker</option>
                                                    <option value='builder-6'>BUILDER</option>
                                                    {/* <option value='handling state projects'>government employee(handling state projects)</option>
                                                    <option value='handling government of India projects'>government employee(handling government of India projects)</option>
                                                    <option value='handling other projects'>government employee(handling other projects)</option> */}
                                                </Field>
                                                <ErrorMessage name="citizen" component="div" className="text-error" />
                                            </jnb.InputGroup>
                                        </jnb.Col>

                                    </jnb.Row>
                                    <br></br>
                                    {showSendOTP && (
                                    <div className='d-flex flex-row justify-content-start px-2'>
                                        <jnb.Col xs={12} sm={12} md={12} lg={1} xl={1} xxl={1}></jnb.Col>
                                        <button type="button" className="btn btn-primary" onClick={() => {
                                            const isValid = Otp(); // validate inputs
                                            if (isValid) {
                                                submitDetails(); // only call if inputs are valid
                                            }
                                        }}>Send OTP</button>
                                    </div>
                                    )}
                                    <br></br>
                                    {showData === true && (
                                        <>
                                            <jnb.Row className='mb-3'>
                                                <jnb.Col xs={12} sm={12} md={12} lg={1} xl={1} xxl={1}></jnb.Col>
                                                <jnb.Col xs={12} sm={12} md={12} lg={5} xl={5} xxl={5}>
                                                    <jnb.InputGroup>
                                                        <span className="mb-5 mb-md-2 field-mandatory px-2"><b>OTP</b></span>
                                                        <Field type="text" name="otp" autoComplete="off" maxLength="6" className="form-control w-100 nb-1 px-2" placeholder="Enter OTP Here" onKeyPress={(e) => { allowNumbersOnly(e) }} />
                                                        <ErrorMessage name="otp" component="div" className="text-error" />
                                                    </jnb.InputGroup>
                                                </jnb.Col>
                                            </jnb.Row>
                                            <jnb.Row className='mb-3'>
                                                <jnb.Col xs={12} sm={12} md={12} lg={1} xl={1} xxl={1}></jnb.Col>
                                                <jnb.Col xs={12} sm={12} md={12} lg={5} xl={5} xxl={5}>
                                                    <div className='d-flex flex-row justify-content-start'>
                                                          {timerActive ? (
                                                            <p>
                                                                Time Remaining: {minutes < 10 ? `0${minutes}` : minutes}:
                                                                {seconds < 10 ? `0${seconds}` : seconds}
                                                            </p>
                                                        )
                                                            : (
                                                                <p>Didn't recieve code?</p>
                                                            )
                                                        }
                                                    </div>
                                                </jnb.Col>
                                                <jnb.Col xs={12} sm={12} md={12} lg={2} xl={2} xxl={2}>
                                                    <div className='d-flex flex-row justify-content-end px-2'>
                                                        <button
                                                             disabled={timerActive}
                                                            style={{
                                                                color: timerActive ? "#DFE3E8" : "#FF5630"
                                                            }}
                                                            onClick={resendOTP}
                                                        >
                                                            Resend OTP
                                                        </button>
                                                    </div>
                                                </jnb.Col>
                                            </jnb.Row>
                                            <jnb.Row className='mb-3'>
                                                <jnb.Col xs={12} sm={12} md={12} lg={1} xl={1} xxl={1}></jnb.Col>
                                                <jnb.Col xs={12} sm={12} md={12} lg={5} xl={5} xxl={5}>
                                                    <jnb.InputGroup>
                                                        <span className="mb-5 mb-md-2 field-mandatory px-2"><b>Password</b></span>
                                                        <div style={{ position: "relative", width: "100%" }}>
                                                            <Field type={showPassword ? "text" : "password"} name="pwd" className="form-control w-100 nb-1" maxLength="12" placeholder="Enter Password" autoComplete="new-password" />
                                                            <span
                                                                onClick={() => setShowPassword(!showPassword)}
                                                                style={{
                                                                    position: "absolute",
                                                                    right: "10px",
                                                                    top: "50%",
                                                                    transform: "translateY(-50%)",
                                                                    cursor: "pointer",
                                                                    color: "#666",
                                                                }}
                                                            >
                                                                {showPassword ? <FaEyeSlash /> : <FaEye />}
                                                            </span>
                                                        </div>
                                                        <ErrorMessage name="pwd" component="div" className="text-error" />
                                                    </jnb.InputGroup>
                                                </jnb.Col>
                                                {/* </jnb.Row>
                                            <br></br>
                                            <jnb.Row> */}
                                                {/* <jnb.Col xs={12} sm={12} md={12} lg={1} xl={1} xxl={1}></jnb.Col> */}
                                                <jnb.Col xs={12} sm={12} md={12} lg={5} xl={5} xxl={5}>
                                                    <jnb.InputGroup>
                                                        <span className="mb-5 mb-md-2 field-mandatory px-2"><b>Confirm Password</b></span>
                                                        <div style={{ position: "relative", width: "100%" }}>
                                                            <Field type={showPassword ? "text" : "password"} name="repwd" className="form-control w-100 nb-1" maxLength="12" placeholder="Confirm Password" />
                                                            <span
                                                                onClick={() => setShowPassword(!showPassword)}
                                                                style={{
                                                                    position: "absolute",
                                                                    right: "10px",
                                                                    top: "50%",
                                                                    transform: "translateY(-50%)",
                                                                    cursor: "pointer",
                                                                    color: "#666",
                                                                }}
                                                            >
                                                                {showPassword ? <FaEyeSlash /> : <FaEye />}
                                                            </span>
                                                        </div>
                                                        <ErrorMessage name="repwd" component="div" className="text-error" />
                                                    </jnb.InputGroup>
                                                </jnb.Col>
                                            </jnb.Row>
                                            <jnb.Row className='mb-3'>
                                                <jnb.Col xs={12} sm={12} md={12} lg={1} xl={1} xxl={1}></jnb.Col>
                                                <jnb.Col xs={12} sm={12} md={12} lg={5} xl={5} xxl={5} className="text-left mt-4">
                                                    <a className="text-black forgot mb-4 " href='/login'>Click here to login</a>
                                                </jnb.Col>
                                                <jnb.Col xs={12} sm={12} md={12} lg={5} xl={5} xxl={5}>

                                                    <div className='d-flex flex-row justify-content-end mt-3'>
                                                        <jnb.Button type="submit" className="btn btn-success" >Click To Register</jnb.Button>
                                                    </div>

                                                </jnb.Col>
                                            </jnb.Row>
                                            {/* <jnb.Row>
                                                <jnb.Col xs={12} sm={12} md={12} lg={12} xl={12} xxl={12} >
                                                    <jnb.InputGroup> */}
                                            {/* <a className="text-black forgot mb-4 float-end" href='/login'>Click here to login</a> */}
                                            {/* </jnb.InputGroup>
                                                </jnb.Col>
                                            </jnb.Row> */}
                                        </>
                                    )}
                                </jnb.Col>

                            </jnb.Row>

                        </div>
                    </jnb.Container>
                </jnb.Form>
            </FormikProvider >
        </>
    )
}
